const BLOCKED_DOMAINS = [
  "news.google.com",
  "google.com",
  "linkedin.com",
  "facebook.com",
  "instagram.com",
  "x.com",
  "twitter.com",
  "youtube.com",
  "reddit.com",
  "bing.com",
];

function normalizeWebsite(website) {
  if (!website) return "";
  return website.startsWith("http") ? website : `https://${website}`;
}

function extractDomain(website) {
  return new URL(normalizeWebsite(website)).hostname.replace("www.", "");
}

export async function sendGmailMessage({ api, to, subject, body, leadId }) {
  const response = await fetch(`${api}/api/gmail/send`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ to, subject, body, leadId }),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Send failed");
  return data;
}

export async function lookupHunterEmail({ api, website }) {
  const domain = extractDomain(website);
  if (BLOCKED_DOMAINS.some((blocked) => domain === blocked || domain.endsWith(`.${blocked}`))) {
    throw new Error("This is an aggregator/social domain. Set the company's real website first.");
  }

  const response = await fetch(`${api}/api/proxy/hunter-domain?domain=${encodeURIComponent(domain)}`);
  const payload = await response.json();
  if (!response.ok || !payload.ok) throw new Error(payload.error || "Hunter search failed");

  const emails = payload?.data?.emails || [];
  return emails.length > 0 ? emails[0].value : "";
}

export async function crawlWebsiteEmail({ api, website }) {
  const response = await fetch(`${api}/api/proxy/crawl-email?url=${encodeURIComponent(website)}`);
  const data = await response.json();
  const emails = data.emails || [];
  return emails.length > 0 ? emails[0] : "";
}

export async function crawlProjectDetails({ api, website }) {
  const response = await fetch(`${api}/api/proxy/crawl-project?url=${encodeURIComponent(website)}`);
  const data = await response.json();
  if (!response.ok || !data.ok) throw new Error(data.error || "Project crawl failed");
  return data;
}

export async function qualifyLeadWithAI({ groqKey, groqChat, localQualify, lead }) {
  if (!groqKey) return localQualify(lead);

  const text = await groqChat(
    `You are a B2B sales qualifier for Maha at WaveProspect, a B2B lead generation platform. Services: web design, UX, animation, RFP/tender consulting, digital marketing.
Key insight: ANY business with NO website is an AUTOMATIC high-value opportunity - that's the #1 signal. Small businesses, local companies, and traditional industries are IDEAL clients. Only recommend "skip" if the company is clearly a large corporation, government body, or non-profit with no commercial need.`,
    `Qualify this lead. Return JSON only: {score:0-100, reasons:["...","...","..."], projectType:"web|ux|rfp|marketing|other", estimatedValue:"small|medium|large", recommendation:"do_it|refer_out|skip", summary:"1 sentence"}
Lead: ${JSON.stringify({ name: lead.name, industry: lead.industry, city: lead.city, country: lead.country, employees: lead.employees, website: lead.website })}`
  );

  const clean = text.replace(/```json|```/g, "").trim();
  return clean ? JSON.parse(clean) : localQualify(lead);
}

export async function generateOutreachDraft({ groqKey, groqChat, localOutreach, lead, channel, tone = "Friendly" }) {
  if (!groqKey) return localOutreach(lead, channel, tone);

  const text = await groqChat(
    `You are Maha at WaveProspect. Write short, personal, non-salesy cold outreach. Max 100 words. No subject line needed unless email.`,
    `Write a ${tone} tone ${channel} message to ${lead.name} (${lead.industry}, ${lead.city}). They ${((lead.websiteStatus === "found") || lead.website) ? "have a website" : lead.websiteStatus === "missing" ? "have NO website - huge pitch opportunity" : "may not have a verified website yet"}. Offer: web design, UX, animation, digital marketing, RFP consulting. Be specific to their industry. Sign off as Maha.`
  );

  const msg = text.trim();
  return msg || localOutreach(lead, channel, tone);
}
